export default __webpack_public_path__ + "static/e_type_pdf-cd5bbb1c8d95685ceaa4434d0e36006e.pdf";